export default function fixCompatibility(config) {
	const aliasMap = {
    data: 'body',
    withCredentials: 'credientials'
  }
  if (/^get$/i.test(config.method)) {
    aliasMap['onDownloadProgress'] = 'progress'
  } else if (/^post|put$/i.test(config.method)) {
    aliasMap['onUploadProgress'] = 'progress'
  }
  Object.keys(aliasMap).forEach(key => {
    config[key] === undefined && (config[key] = config[aliasMap[key]])
  })
  return config
}